import { useCallback } from 'react';
import { Node } from 'reactflow';
import useStore from '../../store/useStore';

// Type definition for proximity edges (can be simplified if not needed elsewhere)
interface ProximityEdge {
    id: string;
    source: string;
    target: string;
    type: string; // Should likely be 'custom' or a specific proximity type
    className?: string;
    sourceHandle?: string | null;
    targetHandle?: string | null;
}

export const useProximityConnections = (isShiftPressed: boolean) => {
    const allNodes = useStore((state) => state.nodes);

    /**
     * Finds the closest node to the dragged node that supports proximity connections.
     * @param node The node being dragged.
     * @returns A potential proximity edge or null.
     */
    const getClosestEdge = useCallback((_node: Node): ProximityEdge | null => {
        // Proximity connect disabled for performance testing
        return null;
    }, [allNodes, isShiftPressed]);

    return { getClosestEdge };
};
